import { Component, Input, OnInit } from '@angular/core';
import { InputNumberModule } from 'primeng/inputnumber';
import { PaginatorModule } from 'primeng/paginator';
import { QuestionBoxComponent } from '@shared/components/question-box/question-box.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BvsHaftpflichtFormModel } from '../../models/form/bvs-haftpflicht-form.model';
import { BoatDataBaseComponent } from '@shared/directives/boat-data-base.component';
import { countryRegisteredAnswerOptions } from '@shared/models/country-registered-answer-options';
import { defaultAnswerOptions } from '@shared/models/default-answer-options';
import { BoatType, CallidusBoatCountryRegistered, BoatSailingArea } from '@backend/models';

@Component({
  selector: 'app-boat-data-haftpflicht',
  imports: [
    InputNumberModule,
    PaginatorModule,
    QuestionBoxComponent,
    TranslocoPipe,
    ReactiveFormsModule
  ],
  templateUrl: './boat-data-haftpflicht.component.html',
  styleUrl: './boat-data-haftpflicht.component.scss'
})
export class BoatDataHaftpflichtComponent extends BoatDataBaseComponent implements OnInit {
  @Input() form!: FormGroup<BvsHaftpflichtFormModel>;

  countryRegisteredAnswerOptions = countryRegisteredAnswerOptions
    .filter(x => x.value === CallidusBoatCountryRegistered.Aut || x.value === CallidusBoatCountryRegistered.Ger);

  protected readonly defaultAnswerOptions = defaultAnswerOptions;

  ngOnInit(): void {
    this.form.controls.bvsBoatInformation.controls.sailingArea.setValue(BoatSailingArea.Binnensee);
  }

  canShowConstructionType(): boolean {
    const infoCtrls = this.form.controls.bvsBoatInformation.controls;
    const isMotorbootMotoryacht = infoCtrls.boatType.value === BoatType.MotorbootMotoryacht;
    const hasMaxKnots = infoCtrls.maxKnotsOver40.value !== null;
    return hasMaxKnots && isMotorbootMotoryacht;

  }

  canShowHasDinghy(): boolean {
    const infoCtrls = this.form.controls.bvsBoatInformation.controls;

    if (infoCtrls.boatType.value === BoatType.MotorbootMotoryacht) {
      return infoCtrls.boatConstructionType.value !== null;
    } else if (infoCtrls.boatType.value === BoatType.SegelbootSegelyacht) {
      return !!this.form.controls.bvsBoatInformation.controls.countryRegistered.value;
    }
    return false;
  }

  canShowBoatMaterialDetails(): boolean {
    return this.form.controls.bvsBoatInformation.controls.isBeibootVorhanden.value !== null;

  }

  canNavigateNextForm(): boolean {
    const boatInformationCtrls = this.form.controls.bvsBoatInformation.controls;

    const hasModelAndYard = !!boatInformationCtrls.boatModel.value && !!boatInformationCtrls.boatYard.value;

    if (!hasModelAndYard) {
      return false;
    }

    if (boatInformationCtrls.boatType.value === BoatType.SegelbootSegelyacht) {
      return this.canNavigateNextForSailBoat();
    }

    return true;
  }

  canShowYardForSailBoat(): boolean {
    return this.form.controls.bvsBoatInformation.controls.sailSurfaceInMetersSquared.value !== null;
  }

  canShowYardForMotorboat(): boolean {
    return this.form.controls.bvsBoatInformation.controls.engineHp.value !== null;
  }

  private canNavigateNextForSailBoat(): boolean {
    const boatInformationCtrls = this.form.controls.bvsBoatInformation.controls;
    return !!boatInformationCtrls.mastMaterial.value && !!boatInformationCtrls.sailSurfaceInMetersSquared.value;
  }

  prevClicked(): void {
    this.prev.emit();
  }

  nextClicked(): void {
    this.next.emit();
  }

  protected readonly BoatType = BoatType;
}
